import React from "react";
import { useTheme } from "../../../context/ThemeContext";
import { formatContent } from "../../../utils/formatContent";

const LongFocusLocationOverview = ({ title, text }) => {
  const { currentBrand, planetDomain, peopleDomain } = useTheme();
  return (
    <>
      <section className="flex flex-col px-4 sm:px-0 column-overview-section">
        <div className="container flex flex-col w-full two-column-content">
          <div className="relative w-full two-column-content_html">
            <div>
              <div
                className="text-h7 font-bold font-heading text-section-title-text planet:text-white planet:font-bold uppercase py-4 sm:py-2"
                dangerouslySetInnerHTML={{
                  __html: title
                }}
              />
              <div className="w-full sm:w-1/2 p-0.5 bg-yellow-standard planet:bg-green-standard mb-6 " />
              <div
                className="not-italic planet:text-gray-generic text-black-lighter pb-4"
                dangerouslySetInnerHTML={{
                  __html: formatContent({
                    content: text,
                    currentBrand,
                    planetDomain,
                    peopleDomain
                  })
                }}
              />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
export default LongFocusLocationOverview;
